import usePromise from "react-use-promise"
import { useEsriModules } from "../common/useEsriModules"
import { PromiseStatus } from "../common/DataProvider"

export const useLayerFeatures = (
  layer: __esri.FeatureLayer | undefined,
  query: __esri.Query | __esri.QueryProperties = {},
  defer: boolean = false
): [__esri.FeatureSet | undefined, Error | undefined, PromiseStatus] => {
  /** Stringify the query so the effect doesn't run infinitely */
  const queryString = JSON.stringify(query)
  const [esriRequest] = useEsriModules<[typeof __esri.request]>([
    "esri/request",
  ])

  /** Run the promise to get the features */
  return usePromise<__esri.FeatureSet | undefined>(
    new Promise((resolve, reject) => {
      if (layer && esriRequest && !defer) {
        layer.when().then((layer) => {
          layer
            .queryFeatures(JSON.parse(queryString))
            .then(resolve)
            .catch(reject)
        })
      } else {
        resolve(undefined)
      }
    }),
    [layer, queryString, esriRequest]
  )
}
